import { render, staticRenderFns } from "./ShuttleRegisterList.vue?vue&type=template&id=53e337ba&"
import script from "./ShuttleRegisterList.vue?vue&type=script&lang=js&"
export * from "./ShuttleRegisterList.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleRegisterList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports